import { useEffect, useState } from "react";
import {
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import mainLogo from "../assets/images2/logo.png";
import { useNavigate } from "react-router-dom";
import { fetchFreeVotes } from "../action/freeVotesAction";
import { useDispatch, useSelector } from "react-redux";

const SplashScreen = () => {
  const navigate = useNavigate();
  const freeVotesData = useSelector((state) => state.freeVotes);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();

  useEffect(() => {
    // fetchFreeVotes();
    dispatch(fetchFreeVotes(token));
  }, []);

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={freeVotesData.loading}
        // onClick={}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box className="splash-main">
        <Box
          className="skip_option"
          sx={{ justifyContent: "start !important" }}
        >
          <Box className="skip">
            <Button
              onClick={() => {
                navigate("/");
              }}
            >
              <ArrowBackIosIcon className="ficon" />
              back
            </Button>
          </Box>
        </Box>

        <Box className="content-wrapper">
          <Box className="content">
            <Box className="img-div">
              <img
                src={mainLogo}
                width="100%"
                height="100%"
                style={{ objectFit: "contain", width: "100%", height: "100%" }}
              />
            </Box>
            <Typography component="h2">Congratulations!</Typography>
            <Typography component="p">
              As a guest, you get 1 free vote per football video per day, 1 per
              day in each pageant competition (pre-round), and 1 vote per Final
              Night round. <br />
              <br />
              Register for a free account to vote more and unlock all features.
            </Typography>
            <Box sx={{ textAlign: "center", marginTop: "30px" }}>
              <Button className="votes-btn" sx={{ cursor: "default" }}>
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00098 23.9482L8 23.9463L7.99707 23.9385C7.99798 23.9418 8.00009 23.945 8.00098 23.9482ZM19.2529 12.9795L19.2568 12.9844C19.5068 13.3698 19.874 13.6859 20.3232 13.8691L20.5215 13.9395C21.0641 14.1048 21.6443 14.0619 22.1533 13.8252L22.1611 13.8213L22.1699 13.8174L26.292 11.8525L23.3115 22.8027H7.68848L4.70703 11.8525L8.83008 13.8174L8.83789 13.8213C9.28516 14.0321 9.78849 14.0923 10.2734 13.9922L10.4795 13.9395C11.0227 13.7734 11.4643 13.4196 11.749 12.9746L11.748 12.9736L15.499 7.15234L19.2529 12.9795Z"
                    stroke="#FFCC29"
                    stroke-width="3.875"
                  />
                  <path
                    d="M15.5714 6.83899L11.422 13.3594L3.71606 10.3956L7.86543 24.0292H23.2774L27.4267 10.3956L20.3135 13.3594L15.5714 6.83899Z"
                    fill="#FFCC29"
                    stroke="#FFCC29"
                    stroke-width="1.9375"
                  />
                </svg>
                {freeVotesData?.data?.data?.free_votes
                  ? freeVotesData?.data?.data?.free_votes
                  : "NA"}{" "}
                Votes
              </Button>
            </Box>

            <Box sx={{ textAlign: "center", marginTop: "37px" }}>
              <Button className="site-btn" onClick={() => navigate("/")}>
                View Now
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SplashScreen;
